import React, { useState } from 'react';
import './styles.css';
import { messageAPI } from '../../services/api';

const ContactEmail = () => {
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    product: '',
    message: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);

    try {
      if (!formData.name.trim()) {
        throw new Error('Full name is required');
      }
      if (!formData.phone.trim()) {
        throw new Error('Phone number is required');
      }
      if (!formData.email.trim()) {
        throw new Error('Email is required');
      }

      const messagePayload = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        subject: `Quote Request - ${formData.product || 'General Inquiry'}`,
        message: formData.message.trim() || `Category: ${formData.product || 'Not specified'}\n\nPhone: ${formData.phone}`,
        phone: formData.phone.trim(),
        product: formData.product.trim()
      };

      const response = await messageAPI.createMessage(messagePayload);

      if (response.success) {
        setSuccess('Quote request sent successfully! We will respond within 24 hours.');
        setFormData({
          name: '',
          phone: '',
          email: '',
          product: '',
          message: ''
        });
        setTimeout(() => {
          setIsQuoteOpen(false);
        }, 2000);
      }
    } catch (err) {
      setError(err.message || 'Failed to send Message request. Please try again.');
      console.error('Message submission error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="quote-section-wrapper">
      <button 
        className={`quote-toggle-btn ${isQuoteOpen ? 'active' : ''}`}
        onClick={() => setIsQuoteOpen(!isQuoteOpen)}
      >
        <i className={`ri-${isQuoteOpen ? 'close-line' : 'mail-line'}`}></i>
        <span>{isQuoteOpen ? 'Close Message' : 'Send a Message'}</span>
      </button>

      {isQuoteOpen && (
        <div className="quote-panel">
          <div className="quote-header">
           
            <h3>Tell us what you need</h3>
            <p>free estimate · 24h response</p>
          </div>

          <form 
            className="quote-form" 
            onSubmit={handleSubmit}
          >
            {error && (
              <div className="form-alert error">
                <i className="ri-error-warning-line"></i>
                <span>{error}</span>
              </div>
            )}

            {success && (
              <div className="form-alert success">
                <i className="ri-check-line"></i>
                <span>{success}</span>
              </div>
            )}

            <div className="form-group">
              <label><i className="ri-user-line"></i> Full name</label>
              <input 
                type="text" 
                name="name"
                placeholder="e.g. James" 
                value={formData.name}
                onChange={handleInputChange}
                required 
              />
            </div>
            <div className="form-group">
              <label><i className="ri-phone-line"></i> Phone</label>
              <input 
                type="tel" 
                name="phone"
                placeholder="+211 91 234 5678" 
                value={formData.phone}
                onChange={handleInputChange}
                required 
              />
            </div>

            <div className="form-group">
              <label><i className="ri-mail-line"></i> Email</label>
              <input 
                type="email" 
                name="email"
                placeholder="you@example.com" 
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="form-group">
              <label><i className="ri-capsule-line"></i> Product / Service</label>
              <input 
                type="text" 
                name="product"
                placeholder="e.g. program, service..." 
                value={formData.product}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group full-width">
              <label><i className="ri-chat-3-line"></i> Additional info / questions</label>
              <textarea 
                name="message"
                placeholder="Please describe what you need, dosage, urgency..."
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>
            </div>

            <div className="quote-footer">
              <button 
                type="submit" 
                className="submit-quote"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <i className="ri-loader-4-line" style={{ animation: 'spin 1s linear infinite' }}></i>
                    <span> Sending...</span>
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line"></i>
                    <span> Send Message</span>
                  </>
                )}
              </button>
            </div>
          </form>
          
          <p className="quote-privacy-note">
            <i className="ri-shield-check-line"></i> Your information is confidential
          </p>
        </div>
      )}
    </div>
  );
};

export default ContactEmail;